import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RateAutomationStoreModule } from './store'

@NgModule({
  imports: [CommonModule, RateAutomationStoreModule],
  exports: [RateAutomationStoreModule],
})
export class RateAutomationsLibraryModule {}
